import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "warning-hint-available-lot"
}
const _hoisted_3 = {
  key: 0,
  class: "input-row"
}
const _hoisted_4 = { class: "input-wr input-price-wr w-100" }
const _hoisted_5 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_6 = {
  key: 1,
  class: "input-row"
}
const _hoisted_7 = { class: "input-wr input-price-wr w-100" }
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = {
  key: 1,
  class: "input-prefix"
}
const _hoisted_10 = {
  key: 2,
  class: "input-row"
}
const _hoisted_11 = { class: "input-wr w-100" }
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = { class: "input-wr w-100" }
const _hoisted_14 = { class: "input-row" }
const _hoisted_15 = { class: "input-wr w-100" }
const _hoisted_16 = {
  key: 3,
  class: "input-row"
}
const _hoisted_17 = { class: "input-wr w-100" }
const _hoisted_18 = {
  key: 4,
  class: "input-row"
}
const _hoisted_19 = { class: "input-wr w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    showClose: false,
    onClose: $setup.setFormToDefaultAndClose,
    classes: "auto-height overflow-visible"
  }, {
    content: _withCtx(() => [
      ($props.lot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-title" }, "Edit lot details", -1)),
            ($setup.availableLotWithApplicants)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "This lot currently has one or more pending reservations forms. Please review all reservation forms before editing the price of this lot."))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              class: "default-form",
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
            }, [
              ($setup.isLotStatusEditable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Lot Price", -1)),
                      _createVNode($setup["Cleave"], {
                        class: _normalizeClass(["input", [{ error: $setup.v$.price.$error }, { 'p-left': $setup.form.price }]]),
                        id: "price",
                        modelValue: $setup.form.price,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.price) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "Lot Price",
                        onBlur: $setup.v$.price.$touch,
                        options: $setup.optionPrice,
                        disabled: $setup.availableLotWithApplicants
                      }, null, 8, ["modelValue", "class", "onBlur", "disabled"]),
                      ($setup.v$.price.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.v$.price.$errors[0].$message), 1))
                        : _createCommentVNode("", true),
                      ($setup.form.price)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["input-prefix", { 'input-prefix-disabled': $setup.availableLotWithApplicants }])
                          }, "$", 2))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Initial deposit", -1)),
                      _createVNode($setup["Cleave"], {
                        class: _normalizeClass(["input", [{ error: $setup.v$.deposit.$error }, { 'p-left': $setup.form.deposit }]]),
                        id: "deposit",
                        modelValue: $setup.form.deposit,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.deposit) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "Initial deposit",
                        onBlur: $setup.v$.deposit.$touch,
                        options: $setup.optionPrice
                      }, null, 8, ["modelValue", "class", "onBlur"]),
                      ($setup.v$.deposit.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.deposit.$errors[0].$message), 1))
                        : _createCommentVNode("", true),
                      ($setup.form.deposit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "$"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Buyer", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.offlineBuyer) = $event)),
                        type: "text",
                        placeholder: "Buyer"
                      }, null, 512), [
                        [
                          _vModelText,
                          $setup.form.offlineBuyer,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Street Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.streetName) = $event)),
                    type: "text",
                    placeholder: "Street Name"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.form.streetName,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Registration date", -1)),
                  _createVNode($setup["DatePicker"], {
                    modelValue: $setup.form.registrationDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.registrationDate) = $event)),
                    max: $setup.maxDate,
                    position: $props.lot.status === $setup.LotStatus.OFFLINE ? 'left top' : 'left bottom',
                    showClearButton: true,
                    onClearRegistrationDate: _cache[5] || (_cache[5] = ($event: any) => ($setup.form.registrationDate = null))
                  }, null, 8, ["modelValue", "max", "position"])
                ])
              ]),
              (($props.lot.status === $setup.LotStatus.CONTRACT_EXECUTED && $setup.checkSubjectToFinance) || $props.lot.status === $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Finance due date", -1)),
                      _createVNode($setup["DatePicker"], {
                        modelValue: $setup.form.financeDueDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.financeDueDate) = $event)),
                        max: $setup.maxDate,
                        position: $props.lot.status === $setup.LotStatus.OFFLINE ? 'left top' : 'left bottom'
                      }, null, 8, ["modelValue", "max", "position"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.UNCONDITIONAL || $props.lot.status === $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label" }, "Settlement date", -1)),
                      _createVNode($setup["DatePicker"], {
                        modelValue: $setup.form.settlementDate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.settlementDate) = $event)),
                        max: $setup.settlementMaxDate,
                        position: $props.lot.status === $setup.LotStatus.OFFLINE ? 'left top' : 'left bottom'
                      }, null, 8, ["modelValue", "max", "position"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32),
            _createElementVNode("div", { class: "controls" }, [
              _createElementVNode("button", {
                class: "button default cancel",
                onClick: $setup.setFormToDefaultAndClose
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary save",
                onClick: $setup.edit
              }, "Save")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}